/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { ChangeDetectorRef, Component, contentChild, NgModule, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { WrapperBase } from "../base";
import { Wrapper } from "../decorators";
import { Toast, ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { Subscription } from "rxjs";
import { CommonModule } from "@angular/common";

@Component({
    selector:      'v-toast',
    encapsulation: ViewEncapsulation.None,
    template:      `<p-toast #component>
                        <ng-container *ngIf="vTemplate() as template">
                            <ng-template let-message #message>
                                <ng-container [ngTemplateOutlet]="$any(template)", [ngTemplateOutletContext]="{$implicit: message}"></ng-container>
                            </ng-template>
                        </ng-container>
                    </p-toast>`,
    providers:  [{ provide: Toast, useExisting: VToastComponent }],
    // eslint-disable-next-line max-len
    inputs:     ["key", "autoZIndex", "baseZIndex", "life", "style", "styleClass", "position", "preventOpenDuplicates", "preventDuplicates", "showTransoformOptions", "hideTransformOptions", "showTransitionOptions", "hideTransitionOptions", "breakpoints"],
    outputs:    ["onClose"],
    standalone: false
})
@Wrapper(Toast)
export class VToastComponent extends WrapperBase implements OnInit, OnDestroy {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vTemplate = contentChild<unknown>('message');
    clearByID: Subscription;

    constructor(public messageService: MessageService, private cd2: ChangeDetectorRef) {
        super();
    }

    override ngOnInit(): void {
        super.init();
        this.clearByID = this.messageService.clearObserver.subscribe((key) => {
            if (!key) return;
            (super.component as Toast).messages = (super.component as Toast).messages?.filter(x => x.id !== key);
            this.cd2.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.clearByID?.unsubscribe();
    }
}
export interface VToastComponent extends Toast {}
@NgModule({
    imports: [
        ToastModule,
        CommonModule,
    ],
    exports: [
        VToastComponent,
    ],
    declarations: [
        VToastComponent
    ],
})
export class VToastModule{}
